import {Pipe, PipeTransform} from '@angular/core';
import {VocTerms} from '../models/voc-term';

@Pipe({
    name: 'filterVocByParent'
})
export class FilterVocByParentPipe implements PipeTransform {

    transform(value: VocTerms, parentField: string, parentId: number): VocTerms {
        const filteredVoc: VocTerms = [];
        if (parentField && parentId) {
            for (let valueIndex = 0; valueIndex < value.length; valueIndex++) {
                if (value[valueIndex][parentField] === parentId) {
                    filteredVoc.push(value[valueIndex]);
                }
            }
        }
        return filteredVoc;
    }

}



// WEBPACK FOOTER //
// ./src/app/pipes/filter-voc-by-parent.pipe.ts